module.exports = __webpack_public_path__ + "bc0bde8ec60da9bef0e2dad3c67340fa.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/br.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/br.svg
// module chunks = 0